import cloneDeep from 'lodash.clonedeep';
import { BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
export class BulkActionSelectionService {
    constructor() {
        this.idsByResourceType = new BehaviorSubject({});
        this._bulkActionMode = new BehaviorSubject(false);
        this.idsByResourceType$ = this.idsByResourceType.asObservable();
        this.bulkActionMode$ = this._bulkActionMode.asObservable();
    }
    /**
     * Bulk Action Mode
     */
    get bulkActionMode() {
        return this._bulkActionMode.value;
    }
    setBulkActionEnabled(enabled) {
        this._bulkActionMode.next(enabled);
    }
    /**
     * Selections
     */
    get numSelectedItems() {
        return Object.values(this.currentItems).reduce((total, ids) => total + ids.size, 0);
    }
    get currentItems() {
        return cloneDeep(this.idsByResourceType.value);
    }
    hasSelectedItems() {
        return this.numSelectedItems > 0;
    }
    isSelected(resourceType, id) {
        const { currentItems } = this;
        return resourceType in currentItems && currentItems[resourceType].has(id);
    }
    selectItem(resourceType, id) {
        const { currentItems: items } = this;
        if (!(resourceType in items))
            items[resourceType] = new Set();
        items[resourceType].add(id);
        this.idsByResourceType.next(items);
    }
    deselectItem(resourceType, id) {
        const { currentItems: items } = this;
        items[resourceType].delete(id);
        if (items[resourceType].size === 0)
            delete items[resourceType];
        this.idsByResourceType.next(items);
    }
    toggleSelectedItem(resourceType, id) {
        if (this.isSelected(resourceType, id)) {
            this.deselectItem(resourceType, id);
        }
        else {
            this.selectItem(resourceType, id);
        }
    }
    clearSelections() {
        this.idsByResourceType.next({});
    }
}
BulkActionSelectionService.ɵfac = function BulkActionSelectionService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || BulkActionSelectionService)(); };
BulkActionSelectionService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: BulkActionSelectionService, factory: BulkActionSelectionService.ɵfac });
